module.exports = __webpack_public_path__ + "static/media/parallax-bg-20.3f45b450.jpg";